import type { StaticEntityType } from "@config";
import { Elements } from "@library-containers/elements";
import { ElementView } from "./Element.view";

export const ElementLibrary = ({ entity }: { entity: StaticEntityType }) => {
  const { settings } = entity;
  const ElementItem = Elements[settings.name];

  return (
    <ElementView entity={entity}>
      {!!ElementItem && <ElementItem entity={entity} />}
    </ElementView>
  );
};
